import axios from "../../js/project-axios.js"

const list = (productId, timeStart) => {
    return axios.get("/warning/list", {
        params: {
            productId,
            timeStart
        }
    });
};

export default {
    list
};